<template>
    <div style="display: flex; justify-content: center;">
        <v-card elevation="0" style="width: 95vw;" @click="handleClick">
            <v-card-title style="justify-content: space-between; padding: 1vh; flex-wrap: nowrap;">
                <div style="word-break: keep-all">
                    {{ alarm.category }} : {{ alarm.alarm_name }}
                </div>
                <div style="align-content: center;">
                    <v-chip v-if="status === 'To do'"
                        style="background-color: #F49301; align-self: end; margin-right: 1.5vw;">{{ $t('_to_do_')
                        }}</v-chip>
                    <v-chip v-if="status === 'In Progress'"
                        style="background-color: #FDEC00; align-self: end; margin-right: 1.5vw;">{{ $t('_in_progress_')
                        }}</v-chip>
                    <v-chip v-if="status === 'Submitted'"
                        style="background-color: #78CFE0; align-self: end; margin-right: 1.5vw;">{{ $t('_submitted_')
                        }}</v-chip>
                </div>
            </v-card-title>

            <v-card-text style="padding: 0vh; padding-left: 3vw;">
                <p v-if="alarm.bloc_id.length!==0"> {{ $t('_bloc_') }} : {{ alarm.bloc_id }}</p>
                <p v-if="alarm.datapoint !== ''"> {{ $t('_pdm_') }} : {{ alarm.datapoint }} </p>
                
                {{ alarm.alarm_description }}
            </v-card-text>
            <v-btn style="float: right; margin-bottom: 1vh; margin-right: 2vw; " @click.stop.prevent="toggleModal">
                {{ $t("_traiter_") }}
            </v-btn>
            <v-btn v-if="voirSupp" style="float: right; margin-bottom: 1vh; margin-right: 2vw; "
                @click.stop.prevent="toggleDelete">
                {{ $t("_supprimer_") }}
            </v-btn>
        </v-card>
        <PopUpForm v-if="modalState" :alarm=this.alarm :answer="this.answer" :status="this.status" @close="toggleModal"
            @submit="submitAnswer" @save="saveAnswer"></PopUpForm>
        <PopUpDelete v-if="supprimer" @confirm="deleteAlarm" @close="toggleDelete"></PopUpDelete>
    </div>


</template>

<script>
import PopUpForm from './PopUpForm.vue';
import backend from '@/api/backend';
import api from '@/api/api';
import PopUpDelete from './PopUpDelete.vue';

export default {

    props: {
        alarm: {
            required: true
        },
        answer: {
            required: false
        },
        status: {
            required: true
        }
    },

    components: { PopUpForm, PopUpDelete },

    data() {
        return {
            installation_id: this.$route.params.id,
            modalState: false,
            voirSupp: false,
            supprimer: false,
        }
    },

    async mounted() {
        const utilisateur = (await api.currentUser()).data.id
        if (this.alarm.user_id === utilisateur) {
            this.voirSupp = true
        }
    },

    methods: {
        toggleModal() {
            this.modalState = !this.modalState;
        },
        handleClick() {
            if (this.$route.name === 'tech-instructions') {
                if (this.alarm.datapoint != "")
                    this.$router.push({
                        name: 'tech-map',
                        params: { id: this.installation_id },
                        query: { mpp: this.alarm.datapoint }
                    })
                else if (this.alarm.bloc_id != [])
                    this.$router.push({
                        name: 'tech-map',
                        params: { id: this.installation_id },
                        query: { bloc: this.alarm.bloc_id }
                    })
                else
                    this.$router.push({
                        name: 'tech-map',
                        params: { id: this.installation_id },
                        query: { geopoint: this.alarm.geopoint }
                    })
            }
        },
        async submitAnswer(updatedAnswer, fileList) {
            updatedAnswer.field_alarm_status = "Submitted"
            
            if (this.answer === undefined) {
                await backend.post_alarm_id(this.alarm.id, this.installation_id, updatedAnswer)
            }
            else {
                await backend.put_alarm_id(this.alarm.id, this.installation_id, updatedAnswer);
            }
            for (var i = 0; i < fileList.length; i++) {
                await backend.put_file_for_alarm(this.alarm.id, fileList[i])
            }
            this.$emit('update', this.alarm.id, updatedAnswer)
            this.toggleModal()
        },
        async saveAnswer(updatedAnswer, fileList) {
            if (this.status !== "Submitted") {
                updatedAnswer.field_alarm_status = "In Progress"
            }
            else {
                updatedAnswer.field_alarm_status = "Submitted"
            }
            
            if (this.answer === undefined) {
                await backend.post_alarm_id(this.alarm.id, this.installation_id, updatedAnswer)
            }
            else {
                await await backend.put_alarm_id(this.alarm.id, this.installation_id, updatedAnswer);
            }
            for (var i = 0; i < fileList.length; i++) {
                await backend.put_file_for_alarm(this.alarm.id, fileList[i])
            }
            this.$emit('update', this.alarm.id, updatedAnswer)
            this.toggleModal()
        },

        toggleDelete() {
            this.supprimer = !this.supprimer
        },

        async deleteAlarm() {
            const alarm_id = this.alarm.id
            await backend.delete_alarmquery_id(alarm_id)
            await backend.delete_alarm_id(alarm_id)
            this.toggleDelete()
            this.$emit("delete")
        }
    },

}

</script>
